import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-custom-qr',
    template: `
  <div class="d-flex flex-column align-items-center">
    <div class="btn btn-primary qr-button">
        <span class="qr-text">{{ 'MAIN.CONTENT.WORKFLOW.PREVIEW.DETECT-QR' | translate }}</span>
    </div>
  </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormlyFieldCustomQR extends FieldType<FieldTypeConfig> {
  get type() {
    return this.to.type || 'text';
  }
}